export const focusClasses =
  'outline-none focus:outline-none focus-visible:outline-solid focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-uniform-green-500';
